module.exports = __webpack_public_path__ + "static/media/2-7.ac293a07.svg";